import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["label", "placement", "spacing", "children", "className", "__css"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// src/button-spinner.tsx
import { Spinner } from "@chakra-ui/spinner";
import { chakra } from "@chakra-ui/system";
import { cx } from "@chakra-ui/shared-utils";
import { useMemo } from "react";
import { jsx } from "react/jsx-runtime";
function ButtonSpinner(props) {
  var label = props.label,
    placement = props.placement,
    _props$spacing = props.spacing,
    spacing = _props$spacing === void 0 ? "0.5rem" : _props$spacing,
    _props$children = props.children,
    children = _props$children === void 0 ? /* @__PURE__ */jsx(Spinner, {
      color: "currentColor",
      width: "1em",
      height: "1em"
    }) : _props$children,
    className = props.className,
    __css = props.__css,
    rest = _objectWithoutProperties(props, _excluded);
  var _className = cx("chakra-button__spinner", className);
  var marginProp = placement === "start" ? "marginEnd" : "marginStart";
  var spinnerStyles = useMemo(function () {
    var _objectSpread2;
    return _objectSpread((_objectSpread2 = {
      display: "flex",
      alignItems: "center",
      position: label ? "relative" : "absolute"
    }, _defineProperty(_objectSpread2, marginProp, label ? spacing : 0), _defineProperty(_objectSpread2, "fontSize", "1em"), _defineProperty(_objectSpread2, "lineHeight", "normal"), _objectSpread2), __css);
  }, [__css, label, marginProp, spacing]);
  return /* @__PURE__ */jsx(chakra.div, _objectSpread(_objectSpread({
    className: _className
  }, rest), {}, {
    __css: spinnerStyles,
    children: children
  }));
}
ButtonSpinner.displayName = "ButtonSpinner";
export { ButtonSpinner };